import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { ArrowButtonNext, ArrowButtonPrev, Day, DayNumber, DayShortName, MonthFullName, SliderProvider } from './styled';
import ScheduleTreatmentEventsViewModel from './viewModel';
import Typography from '@mui/material/Typography';
import { getFullMonthName } from '../../../../lib/dayjs';

export type ScheduleTreatmentEventsProps = {
  days: Date[];
  setSelectedDay: (day: Date | null | undefined) => void;
  selectedDay?: Date | null;
};

type CustomArrowProps = {
  onClick?: React.MouseEventHandler<any>;
};

export default function ScheduleTreatmentEvents({ days, setSelectedDay, selectedDay }: ScheduleTreatmentEventsProps) {
  const {
    Slider,
    settings,
    next,
    prev,
    ref,

    formatDateToDisplayDayOfWeek,
    formatTimeToDisplayDayOfMonthTwoDigits
  } = ScheduleTreatmentEventsViewModel({ days, setSelectedDay, selectedDay });

  const PrevArrow = ({ onClick }: CustomArrowProps): React.JSX.Element => (
    <ArrowButtonPrev onClick={onClick} disableRipple>
      <ArrowBackIcon />
    </ArrowButtonPrev>
  );
  const NextArrow = ({ onClick }: CustomArrowProps): React.JSX.Element => (
    <ArrowButtonNext onClick={onClick} disableRipple>
      <ArrowForwardIcon />
    </ArrowButtonNext>
  );

  return (
    <>
      <MonthFullName variant="body1B">{selectedDay ? getFullMonthName(selectedDay) : 'Selecione um dia'}</MonthFullName>
      <SliderProvider>
        <PrevArrow onClick={() => prev()} />
        <Slider {...settings} ref={ref}>
          {days.map((day, index) => (
            <Day
              key={index}
              onClick={() => setSelectedDay(day)}
              className={`${selectedDay?.getTime() === day.getTime() ? 'selected' : ''}`}
            >
              <DayShortName>{formatDateToDisplayDayOfWeek(day)}</DayShortName>
              <DayNumber variant="body2R">
                <Typography variant="body2R" component={'span'}>
                  {formatTimeToDisplayDayOfMonthTwoDigits(day)}
                </Typography>
              </DayNumber>
            </Day>
          ))}
        </Slider>
        <NextArrow onClick={() => next()} />
      </SliderProvider>
    </>
  );
}
